import SeatChoiceUIModel from './seat-choice';

class TicketedSegmentChoiceUIModel {
  constructor({
    emd = undefined,
    fareType = null,
    seat = undefined,
    seatSelectionFee = null,
    segmentCode = undefined,
    status = null,
    redeemedCP = null,
  } = {}) {
    this.emd = emd;
    this.fareType = fareType;
    this.seat = new SeatChoiceUIModel(seat);
    this.seatSelectionFee = seatSelectionFee;
    this.segmentCode = segmentCode;
    this.status = status;
    this.isPaid = true;
    this.redeemedCP = redeemedCP;
  }

  hasSeatByCode(code) {
    return this.code === code;
  }

  getTotal() {
    return this.seat.currency ? this.seat.getTotal() : (this.seatSelectionFee ? this.seatSelectionFee.total : 0);
  }

  getTotalPoints() {
    return this.seat.currency ? this.seat.getTotalPoints() : (this.seatSelectionFee ? this.seatSelectionFee.totalCPPoints : 0);
  }

  toApi() {
    return {
      '_meta':{
        'class':'TicketedSegmentChoice',
      },
      'segmentCode': this.segmentCode,
      'seat': this.seat.toApi(),
    };
  }
}

export default TicketedSegmentChoiceUIModel;
